import React, { Component } from 'react';
import AccountSettingsStore from 'stores/AccountSettingsStore'
import { DropdownButton, MenuItem, Button, FormControl, FormGroup, ControlLabel } from 'react-bootstrap'
import Fontawesome from 'react-fontawesome'
import { Checkbox } from 'react-icheck'
import Select from 'react-select'
import './Item.css'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {
      data:[],
      format_options:[],
      is_all_format:false,
      bf_running_forever_id:'0',
      bf_zero_pad_digit:'1'
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  // componentWillReceiveProps(newProps) {
  //   if (newProps.settings.show&&newProps.settings.show!==this.props.settings.show) {
  //     this.loadData()
  //   }
  // }

  loadData() {
    AccountSettingsStore.loadDocumentNumberFormat((result)=>{
      this.setState({data:result.data,format_options:result.format_options,bf_running_forever_id:result.bf_running_forever_id,bf_zero_pad_digit:result.bf_zero_pad_digit})
    })
  }

  onSaveClick() {
    let {data,bf_running_forever_id,bf_zero_pad_digit} = this.state
    let {messages} = this.props
    let postData = {data:data,bf_running_forever_id:bf_running_forever_id,bf_zero_pad_digit:bf_zero_pad_digit}
    AccountSettingsStore.saveDocumentNumberFormat(postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:messages['Notice'],
          message:messages['Success Msg'],
          level:'info',
          position:'tc'
        });
      }  
    },()=>{
      this._notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Error Msg'],
        level:'error',
        position:'tc'
      });  
    })    
  }

  onFormChange(index,field,e) {
    let {data} = this.state
    data[index][field] = e.target.value
    this.setState({data:data})
  }

  onFormatSelect(index,format) {
    let {data,is_all_format} = this.state
    if (!is_all_format)
      data[index].format = format
    else {
      data = data.map((item,index)=>{
        item.format = format
        return item
      })
    }  
    this.setState({data:data})
  }

  onIsAllFormat() {
    let {is_all_format} = this.state
    is_all_format = !is_all_format
    this.setState({is_all_format:is_all_format})
  }

  onRunningForeverId() {
    let {bf_running_forever_id} = this.state
    if (bf_running_forever_id==='0')
      bf_running_forever_id = '1'
    else if (bf_running_forever_id==='1')
      bf_running_forever_id = '0'  
    this.setState({bf_running_forever_id:bf_running_forever_id})
  }

  onZeroPadDigitChange(e) {
    this.setState({bf_zero_pad_digit:e.value})
  }

  renderDropDown(format,indexs) {
    let {format_options} = this.state
    return(
      <DropdownButton id='dd-format' bsStyle='link' title={format} onSelect={this.onFormatSelect.bind(this,indexs)}>
        {format_options.map((item,index)=>(
          <MenuItem key={index} eventKey={item.value}>{item.name}</MenuItem>
        ))}
      </DropdownButton>
    )
  }

  renderRowData() {
    let {data} = this.state
    let {messages} = this.props
    if (data.length===0) {
      return(<tr><td colSpan={5}>{messages['No Data']}</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.doc_title}</td>
              <td className='text-center'>
                <FormControl className='text-center' value={item.prefix_format} onChange={this.onFormChange.bind(this,index,'prefix_format')} /> 
              </td>
              <td className='text-center'>{this.renderDropDown(item.format,index)}</td>
              <td className='text-center'>
                <FormControl className='text-center' value={item.current_no} onChange={this.onFormChange.bind(this,index,'current_no')} />
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div>
        <table className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th style={{width:'50px'}} className='text-center'>{messages['Seq']}</th>
              <th style={{width:'150px'}} className='text-center'>{messages['Doc Title']}</th>
              <th style={{width:'100px'}} className='text-center'>{messages['Prefix Format']}</th>
              <th style={{width:'200px'}} className='text-center'>{messages['Format']}</th>
              <th style={{width:'100px'}} className='text-center'>{messages['Current No']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderConfig() {
    let {is_all_format,bf_running_forever_id,bf_zero_pad_digit} = this.state
    let {messages} = this.props
    return(
      <div>
        <FormGroup>
          <Checkbox
            onChange={this.onIsAllFormat.bind(this)}
            checked={is_all_format}
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            label={' '+messages['Same Run Number']}
          />
        </FormGroup>  
        <FormGroup>
          <Checkbox
            onChange={this.onRunningForeverId.bind(this)}
            checked={bf_running_forever_id==='1'?true:false}
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            label={' '+messages['Continuous Run Number']}
          />
        </FormGroup>  
        <FormGroup>
          <ControlLabel>{messages['Zero Number Display']}</ControlLabel>
          <Select 
            style={{width:'300px'}}
            placeholder={'--- '+messages['Select Display']+' ---'}
            clearable={false}
            value={bf_zero_pad_digit}
            options={[{label:'01',value:'1'},{label:'001',value:'2'},{label:'0001',value:'3'},{label:'00001',value:'4'}]}
            onChange={this.onZeroPadDigitChange.bind(this)}
          />
        </FormGroup>  
      </div>
    )
  }

  renderFormButton() {
    let {messages} = this.props
    return(
      <div className='text-right'>
        <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><Fontawesome name='save' /> {messages['Save']}</Button>
      </div>
    )
  }

  render() {
    let {messages} = this.props
    return(
  		<div className='account-settings-menu-1'>
        <h3>{messages['Title']}</h3>
        {this.renderConfig()}
        {this.renderTable()}
        <br />
        {this.renderFormButton()}
        <NotificationSystem ref="notificationSystem" />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu1.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu1/Item.js